<template>
  <div class="actions" v-if="showActions">
    <component
      v-for="action in filteredActions"
      :key="action.type"
      :is="action.type"
      :ref="action.ref"
      :api="action.api"
      :actionData="action.data"
      :participants="participants"
      :selectedParticipants="selectedParticipants"
      :group="group"
    />
  </div>
</template>

<script>
import { eventBus } from '@/lib/events';
import { mapGetters, mapState } from 'vuex';

import ActionInvites from './ActionInvites';
import ActionEntertain from './entertain/ActionEntertain';
import ActionVideo from './video/ActionVideo';
import ActionGroup from './ActionGroup';
import ActionPresentation from './presentation/ActionPresentation';
import ActionPreScreen from '@/components/rooms/actions/questionnaire/ActionPreScreen';
import ActionPostScreen from '@/components/rooms/actions/questionnaire/ActionPostScreen';
import ActionControlVolume from './ActionControlVolume';
import ActionPrioritize from './ActionPrioritize';
import ActionScreenShare from './screenShare/ActionScreenShare';

export default {
  name: 'ActionsSection',
  props: {
    selectedParticipants: {},
    participants: {},
    group: {},
    actions: {},
  },
  components: {
    ActionInvites,
    ActionEntertain,
    ActionVideo,
    ActionGroup,
    ActionPresentation,
    ActionPreScreen,
    ActionPostScreen,
    ActionControlVolume,
    ActionPrioritize,
    ActionScreenShare,
  },
  computed: {
    ...mapState('rooms', ['roomInfo']),
    ...mapGetters('rooms', ['isHost']),
    showActions() {
      let firstAction = this.filteredActions[0] || {};
      return firstAction?.api;
    },
    filteredActions() {
      return this.actions.filter((action) => {
        return !action.hidden;
      });
    },
  },
  methods: {
    relayAction(actionMessage) {
      if (actionMessage.to.identity !== this.roomInfo.identity) {
        return false;
      }

      const actionRef = this.getActionRef(actionMessage.type);
      if (actionRef?.received) {
        actionRef.received(actionMessage);
      }
    },

    actionStateUpdate(actionState) {
      if (!this.isHost || !actionState.type) return false;

      const type = actionState.type;
      delete actionState.type;

      let action = this.getActionByType(type);
      if (!action) return false;

      action.api.trigger('stateUpdate', actionState);
    },

    clearActionsContexts() {
      this.filteredActions.forEach((action) => {
        let actionRef = this.getActionRef(action.type);

        if (actionRef?.contexts.length) {
          actionRef.clearContextForGroup();
        }
      });
    },

    clearActionsStates() {
      this.filteredActions.forEach((action) => {
        let actionRef = this.getActionRef(action.type);
        if (actionRef?.receivedState) {
          actionRef.receivedState = {};
        }
      });
    },

    selectAction(action) {
      let actionRef = this.getActionRef(action.type);
      if (actionRef) {
        actionRef.selected();
      }
    },

    // helpers
    getActionByType(type = '') {
      return this.actions.find((a) => {
        return a.type === type;
      });
    },

    getActionRef(type = '') {
      let action = this.getActionByType(type);
      if (!action?.ref) return false;

      let ref = this.$refs[action.ref];
      return Array.isArray(ref) ? ref[0] : ref;
    },
  },
  created() {
    eventBus.on('participantAction', (action) => {
      this.relayAction(action);
    });

    eventBus.on('actionStateChange', (action) => {
      this.actionStateUpdate(action);
    });

    eventBus.on('clearActionsContexts', () => {
      this.clearActionsContexts();
    });

    eventBus.on('clearActionsStates', () => {
      this.clearActionsStates();
    });

    eventBus.on('selectAction', (action) => {
      this.selectAction(action);
    });
  },
};
</script>
